import {onDomReady} from "../lib/on_dom_ready";

onDomReady(() => {
  const employerIdentifierRows = document.querySelectorAll("tr#employer_identifier_row");

  employerIdentifierRows.forEach((row) => {
    row.addEventListener("click", () => {
      employerIdentifierRows.forEach((item) => {
        item.style.fontWeight = "";
      });

      row.style.fontWeight = "bold";
    });
  });
});
